<template>
    <div>
        <CModal
            size="lg"
            add-content-classes="border-radius-1"
            :show.sync="isShow"
            :centered="true"
            :close-on-backdrop="false"
        >
          <template #header-wrapper>
            <div class="mb-5"></div>
          </template>
          <template #body-wrapper>
            <CRow class="justify-content-center ">
              <CCol col="10">
                <CRow>
                  <CCol>
                    <CCol col="12">
                      <CSelect
                          label="Organization"
                          :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                          :options="organizations"
                          @update:value="onSelectOrganizations"

                      />
                    </CCol>
                    <CCol col="12">
                      <CSelect
                          label="Agency"
                          :horizontal="{label: 'col-sm-3', input: 'col-sm-9'}"
                          :options="agencys"
                          @update:value="onSelectAgencys"
                      />
                    </CCol>

<!--                    <CCol col="12" class="text-right">-->
<!--                      <CButton v-c-tooltip.hover.click="'SEND'" size="sm" color="danger" shape="pill" variant="outline" @click="onCancel"  >-->
<!--                        <CIcon name="cil-ban"/> <samp class=" mr-1">SEARCH</samp>-->
<!--                      </CButton>-->
<!--                    </CCol>-->

<!--                    <CDropdownDivider/>-->
                    <CCol>
<!--                      {{accounts}}-->
                      <CDataTable
                          :table-filter="{label:''}"
                          :hover="hover"
                          :striped="striped"
                          :bordered="bordered"
                          :small="small"
                          :fixed="fixed"
                          :items="accounts"
                          :fields="fields"
                          :items-per-page="small ? 50 : 5"
                          :dark="dark"
                          pagination
                      >
                        <template #index="{item,index}">
                          <td class="text-center"> {{ index + 1 }}</td>
                        </template>

                        <template #avata="{item,index}">
                          <td>
                            <div class="c-avatar">
                              <img :src="item.userinfo.image.src" class="c-avatar-img" alt="" @error="errorImage">
                              <span
                                  class="c-avatar-status"
                                  :class="`bg-success`"
                              ></span>
                            </div>
                          </td>
                        </template>

                        <template #action="{item}">
                          <td style="width: 140px">
                            <CRow>
                              <CCol class="text-center" >
                                <CButton v-if="!object.children.filter(objs => { return (objs.by.accounts.code == item.value.accounts.code)}).length" class="mr-1" v-c-tooltip.hover.click="'ADD'" size="sm" color="success" shape="pill" variant="outline" @click="onAddOrganization(item)"  >
                                  <CIcon name="cil-plus"/>
                                </CButton>

                                <CButton v-if="object.children.filter(objs => { return (objs.by.accounts.code == item.value.accounts.code)}).length" class="mr-1" v-c-tooltip.hover.click="'ADD'" size="sm" color="danger" shape="pill" variant="outline" @click="onRemoveOrganization(item)"  >
                                  <CIcon name="cil-minus"/>
                                </CButton>

                              </CCol>
                            </CRow>
                          </td>
                        </template>

<!--                        <template #firstName="{item,index}">-->
<!--                          <td>-->
<!--                            <p class="mb-0"> {{ item.prefix }} {{ item.firstName }}</p>-->
<!--                          </td>-->
<!--                        </template>-->

<!--                        <template #members="{item,index}"  >-->
<!--                          <td  @click="toggleDetails(item, index)">-->
<!--                            <p class="mb-0"> {{ item.authen.filter(obj => { return (obj.type == "66a06852660ccb1debade7c5")})[0].username }}</p>-->
<!--                            <p class="mb-0" style="white-space: nowrap;">{{ item.userinfo.prefix.filter(item => { return (item.key == lang ) })[0].value }} {{ item.userinfo.firstName.filter(item => { return (item.key == lang ) })[0].value }} {{ item.userinfo.lastName.filter(item => { return (item.key == lang ) })[0].value }}</p>-->
<!--                          </td>-->
<!--                        </template>-->


<!--                        <template #info="{item,index}">-->
<!--                          <td>-->
<!--                            <p class="mb-0"> E-mail : {{ item.authen.filter(item => { return (item.email != null ) })[0].email }} </p>-->
<!--                            <p class="mb-0"> Mobile : {{ item.userinfo.msisdn }} </p>-->
<!--                          </td>-->
<!--                        </template>-->

                      </CDataTable>
                    </CCol>

                    <CCol col="12" class="text-right">
                      <CButton v-c-tooltip.hover.click="'SEND'" size="sm" color="danger" shape="pill" variant="outline" @click="onCancel"  >
                        <CIcon name="cil-ban"/> <samp class=" mr-1">CLOSE</samp>
                      </CButton>
<!--                      <CButton  v-c-tooltip.hover.click="'SEND'" size="sm" color="info" shape="pill" variant="outline" @click="onSend"  >-->
<!--                        <CIcon name="cil-save"/> <samp class=" mr-1">SAVE</samp>-->
<!--                      </CButton>-->
                    </CCol>

                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </template>
          <template #footer-wrapper>
            <div class="mb-5"></div>
          </template>
        </CModal>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        name: 'SearchProfile',
        props:{
          object:{
            type: Object,
            default: {
              children:{
                type: Array,
                default: []
              }
            }
          },
          isShow: {
            type: Boolean,
            default: false
          },

          fields: {
            type: Array,
            default() {
              return [
                {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
                {key: "code", label: "รหัสพักงาน",  _style: 'width:40px;'},
                {key: "info", label: "ชื่อ - สกุล", },
                // {key: "lastName", label: "สกุล",  _style: 'width:100px;'},
                // {key:"avata", label:"", _style: 'width:50px; text-align: center'},
                // {key:"members", label:"ชื่อ-สกุล",  _style: 'width:200px;'},
                // {key:"agency", label:"สังกัด",  _style: 'width:190px; text-align: center'},
                {key:"action", label: "#", _style: 'text-align: center'}
                // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
              ]
            }
          },
          type: {
            type: String,
            default: 'cil-user'
          },
          hover: Boolean,
          striped: Boolean,
          bordered: Boolean,
          small: Boolean,
          fixed: Boolean,
          dark: Boolean,

        },
        data: function () {
            return {

              option: {
                organizations: null,
                agencys: 1,
              },
              organizations:[],
              agencys:[],
              accounts:[],
              // accounts:[]

              data:{
                accounts:[],
              }
            }
        },
        mounted() {
          // this.onInit();
        },

        created() {
          this.onInit();
          // this.onLoadAccount();
        },

        beforeDestroy() {

        },

        methods: {
          errorImage(e) {
            e.target.src = "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
          },

          onInit(){
            this.$store.dispatch("organization/config",{})
            this.$store.dispatch("agency/config",{})
            // this.$store.dispatch("member/config",{})
          },

          onSelectOrganizations(value, e) {
            this.option.organizations = value;
            this.$emit("option", this.option)
          },

          onSelectAgencys(value, e) {
            this.option.agencys = value;
            this.$emit("option", this.option)

            var body = {};
            (value != 0)?body.agency = value:null;
            this.$store.dispatch("member/config",body)
          },

          onLoadAccount(){
            this.$store.dispatch("member/config",{})
          },

          onCancel(){
            this.$emit("update", false)
          },

          onAddOrganization(item){

            var by = {};
            by._id = item.value._id;
            by.accounts = item.value.accounts;
            by.agency = item.value.agency;
            by.fields = item.value.fields;


            var objs = {};
            objs.by = by;
            objs.children = [];
            this.$props.object.children.push(objs)

          },

          onRemoveOrganization(item){

            var objs = {};
            objs.by = item.value._id;
            objs.src = "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";
            objs.name = item.info;
            objs.title = item.position;
            objs.children = [];

            var isHave = this.$props.object.children.filter(objs => { return (objs.by.accounts.code != item.value.accounts.code) })
            this.$props.object.children = isHave;
          },




          onSend(){
            this.$emit("update", false)
          },

          onCheck(objs,item){
            try {
              return objs.children.filter(objs => { return (objs._id == item.code)}).length
            }catch (e) {
              return false
            }
          }

        },

        computed: {
            ...mapGetters({
              lang: 'setting/lang',
              organization: 'organization/organization',
              agency: 'agency/item',
              account:'member/members'
            })
        },

        watch: {
          object: function (value) {
            console.log(value)
            var body = {};
            // body.agency = value.agency._id;

            // (value.agency._id != 0)?body.agency = value.agency._id:null;
            this.$store.dispatch("member/config",body)
          },
          organization: function (value) {

            this.organizations = [];
            var lang = this.$store.getters['setting/lang']
            var items = [];
            value.filter(item => {
              var objs = item.title.filter(title => {
                if (title.key == lang) {
                  return title
                }
              })[0].value;
              var data = {};
              data.label = objs
              data.value = item._id;
              items.push(data)
            })
            this.organizations = items;
          },

          agency: function (value) {

            this.agencys = [];
            var lang = this.$store.getters['setting/lang']
            var items = [];

            var data = {};
            data.label = "-";
            data.value = 0;
            items.push(data)

            value.filter(item => {
              var objs = item.title.filter(title => {
                if (title.key == lang) {
                  return title
                }
              })[0].value;
              var data = {};
              data.label = objs
              data.value = item._id;
              items.push(data)
            })
            this.agencys = items;

            var body = {};
            body.agency = this.agencys[0].value;
            this.$store.dispatch("member/config",body)
          },

          account: function (value) {
            this.accounts = [];
            var lang = this.$store.getters['setting/lang']
            var items = [];
            value.filter(item => {
              var objs = {};
              try {
                objs.code = item.accounts.code
              }catch (e) {

              }
              objs.info = item.accounts.userinfo.prefix.filter(title => {
                if (title.key == lang) {
                  return title
                }
              })[0].value +" "+item.accounts.userinfo.firstName.filter(title => {
                if (title.key == lang) {
                  return title
                }
              })[0].value+" "+ item.accounts.userinfo.lastName.filter(title => {
                if (title.key == lang) {
                  return title
                }
              })[0].value;
              objs.agency = item.agency.title.filter(title => {
                if (title.key == lang) {
                  return title
                }
              })[0].value
              // objs.position = item.position.title.filter(title => {
              //   if (title.key == lang) {
              //     return title
              //   }
              // })[0].value
              objs.value = item;



              items.push(objs)
            })

            this.accounts = items;

          }
        }
    }
</script>

<style>
</style>
